module.exports = __webpack_public_path__ + "static/media/Logo__RobinHood.26f1bdcb.svg";